import { COMMON_EVENT_NAMES } from "../../../constants";

export const EVENT_NAME = {
  REFERRAL_LINK_CLICKED: "Referral Link Clicked",
  NAVIGATED_TO: COMMON_EVENT_NAMES.NAVIGATED
};
